<!-- src/components/projects/Ambients.vue -->
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <select class="form-control" id="ambient-location" v-model="location">
          <option value="">Select a Location</option>
          <option
            v-for="location in locations"
            :key="location.id"
            :value="location.id"
          >
            {{ location.name }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="ambient-name"
            placeholder="Enter Ambient Name"
            v-model="name"
            @keyup.enter="addAmbient"
          />
          <button
            class="btn btn-success"
            @click="addAmbient"
            :disabled="!name.trim() || !location"
          >
            <i class="bi bi-plus-circle"></i> Add
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Location</th>
              <th>Ambient</th>
              <th style="width: 60px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ambient in ambients" :key="ambient.id">
              <td>{{ ambient.id }}</td>
              <td>
                <select
                  v-if="editingId === ambient.id"
                  class="form-control"
                  v-model="editingLocation"
                >
                  <option
                    v-for="location in locations"
                    :key="location.id"
                    :value="location.id"
                  >
                    {{ location.name }}
                  </option>
                </select>
                <span v-else>{{ getLocationName(ambient.location) }}</span>
              </td>
              <td>
                <input
                  v-if="editingId === ambient.id"
                  v-model="editingName"
                  class="form-control"
                  placeholder="New Name"
                  @keyup.enter="saveEdit(ambient.id)"
                />
                <span v-else>{{ ambient.name }}</span>
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <button
                    v-if="editingId === ambient.id"
                    @click="saveEdit(ambient.id)"
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                  <button
                    v-else
                    @click="editAmbient(ambient)"
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button
                    @click="deleteAmbient(ambient.id)"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { useProjectStore } from "@/stores/projectStore";
import { ref, computed } from "vue";

export default {
  setup() {
    const store = useProjectStore();
    const location = ref("");
    const name = ref("");
    const editingId = ref(null);
    const editingLocation = ref("");
    const editingName = ref("");

    const locations = computed(() => store.getAllLocations());
    const ambients = computed(() => store.getAllAmbients());

    const addAmbient = async () => {
      if (!location.value || !name.value.trim()) return;
      await store.createAmbient({
        location: location.value,
        name: name.value.trim(),
      });
      location.value = "";
      name.value = "";
    };

    const editAmbient = (ambient) => {
      editingId.value = ambient.id;
      editingLocation.value = ambient.location;
      editingName.value = ambient.name;
    };

    const saveEdit = async (id) => {
      if (!editingLocation.value || !editingName.value.trim()) return;
      await store.updateLocation(
        id,
        editingLocation.value,
        editingName.value.trim()
      );
      editingId.value = null;
      editingLocation.value = "";
      editingName.value = "";
    };

    const deleteAmbient = async (id) => {
      try {
        await store.deleteAmbient(id);
      } catch (error) {
        console.error("Failed to delete ambient:", error);
      }
    };

    // Função para buscar o nome do location com base no ID
    const getLocationName = (locationId) => {
      const location = locations.value.find((loc) => loc.id === locationId);
      return location ? location.name : "Unknown Location";
    };

    return {
      locations,
      ambients,
      location,
      name,
      editingId,
      editingLocation,
      editingName,
      addAmbient,
      editAmbient,
      saveEdit,
      deleteAmbient,
      getLocationName,
    };
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.table {
  margin-top: 20px;
}

.form-label {
  font-weight: bold;
}

.text-danger {
  font-size: 0.9em;
}
</style>
